'use strict'

class AnimatedBillboard {

	constructor() {

		var $volInput = jQuery('#volumeChanger input'),
			$videoLink = jQuery('#video-link'),
			$volIcon  = jQuery('#volumeChanger .fas.volume-change'),
			$videoTrack    = jQuery('#video-link track'),
			$iconElem = jQuery('#volumeChanger .play-pause'),
			$windowWidth = jQuery(window).width(),
			$parentElem = jQuery('.dd-animated-billboard');

		jQuery('#video-play').click(function(){
			if(jQuery(this).hasClass('video_upload')) {
				$videoLink.get(0).play();
				jQuery(this).addClass('playing');
			}
			else {
		    	var video_src = jQuery("#video").attr('src');
		        video_src = video_src.replace("autoplay=0", "autoplay=1");
		      	jQuery( "#video" ).attr({
		        	src: video_src    
		        });
		    }   
		});

		jQuery('.dd-animated-billboard').on('click', '#video-link', function() {
			$iconElem.toggleClass('fa-pause').toggleClass('fa-play');
			$videoLink.toggleClass('opacity-unset');
		    if($parentElem.hasClass('video-playing')) {
		        jQuery(this).get(0).pause();
		        $parentElem.removeClass('video-playing');
		    } else {
		        jQuery(this).get(0).play();
		        $parentElem.addClass('video-playing');
		    }
		});

		jQuery('#volumeChanger .play-pause, .dd-animated-billboard-content.align-copy-center, .play-icon-container.desktop-icon, .play-icon').click( function() {
			$contentElem = jQuery('.dd-animated-billboard-content');
			$iconElem.toggleClass('fa-pause').toggleClass('fa-play');
			$videoLink.toggleClass('opacity-unset');
			$videoElement = jQuery('.dd-animated-billboard #video-link');
			if ( $windowWidth < 991) {
				$playIconElem = jQuery('play-icon-container');
				$playIconElem.toggleClass('display-none');
			}
		    if($parentElem.hasClass('video-playing')) {
		        $videoElement.get(0).pause();
		        $parentElem.removeClass('video-playing');
		       
		    } else {
		        $videoElement.get(0).play();
		        $parentElem.addClass('video-playing');
		    }

		});

		$volInput.on('input', function() {
		    $videoLink.prop("volume", this.value);
		    if($videoLink.get(0).volume == 0) {
		    	$volIcon.addClass('fa-volume-mute').removeClass('fa-volume');
		    } else {
		    	$volIcon.addClass('fa-volume').removeClass('fa-volume-mute');
		    	$videoLink.prop("muted", false);
		    }
		    
		});

		jQuery('.fa-closed-captioning').on('click', function() {
			if($videoTrack.attr('kind') == 'subtitles') {
				$videoTrack.attr('kind','metadata');
				jQuery(this).removeClass("caption-off");
				jQuery(this).addClass("caption-on");
			} else {
				$videoTrack.attr('kind','subtitles');
				jQuery(this).removeClass("caption-on");
				jQuery(this).addClass("caption-off");
			}
		});

		$volIcon.on('click', function() {
			jQuery(this).toggleClass('fa-volume-mute fa-volume');
			if($videoLink.prop("muted") || $videoLink.get(0).volume == 0) {
		   		$videoLink.prop("muted", false);	
		   		$videoLink.prop("volume", 1);
		   		$volInput.prop('value',1);
			} else {
				$videoLink.prop("muted", true);
				$volInput.prop('value',0);
			}
		});


		if($videoLink.prop("muted")) {
			$volInput.prop('value',0);
		}
		
	}

}